import { useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useEQM2060_R01Store } from "./Store_EQM2060_R01";
import { AgGridReact } from "ag-grid-react";
import { Content_EQM2060_R01 } from "./Content_EQM2060_R01";
import { EQM2060_R01Dto } from "./Dto_EQM2060_R01";
import { SearchSection_EQM2060_R01 } from "./SearchSection_EQM2060_R01";
import { Table_EQM2060_R01 } from "./Table_EQM2060_R01";

export const Container_EQM2060_R01 = () => {
	const { initData, EQM2060_R01List } = useEQM2060_R01Store();

	const gridRef = useRef<AgGridReact<EQM2060_R01Dto>>(null);
	const [clickable, setClickable] = useState(true);

	const {
		fetchData,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleExcelClick,
		handleSaveClick,
		handleNickel1PdfClick,
		handleNickel2PdfClick,
		handleOilWaterPdfClick,
	} = Content_EQM2060_R01({
		gridRef,
		setClickable,
	});

	const containerRef = useRef<HTMLDivElement>(null);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_EQM2060_R01
				onEnterKeyDown={fetchData}
				onNickel1PdfClick={handleNickel1PdfClick}
				onNickel2PdfClick={handleNickel2PdfClick}
				onOilWaterPdfClick={handleOilWaterPdfClick}
			/>
			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				<Table_EQM2060_R01 
					clickable={clickable}
					setClickable={setClickable}
					gridRef={gridRef} 
				/>
			</div>
			<Message />
		</div>
	);
};

